// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicProfileIdRouteImport } from './routes/_public/$profileId'
import { Route as ProtectedExampleProtectedRouteRouteImport } from './routes/_protected/example-protected-route'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicProfileIdRoute = PublicProfileIdRouteImport.update({
            id: '/$profileId',path: '/$profileId',getParentRoute: () => PublicRoute
          })
const ProtectedExampleProtectedRouteRoute = ProtectedExampleProtectedRouteRouteImport.update({
            id: '/example-protected-route',path: '/example-protected-route',getParentRoute: () => ProtectedRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })





const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ProtectedRouteChildren = {
  ProtectedExampleProtectedRouteRoute: ProtectedExampleProtectedRouteRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const PublicRouteChildren = {
  PublicProfileIdRoute: PublicProfileIdRoute,PublicIndexRoute: PublicIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,PublicRoute: PublicRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)